export default {"src":"/_next/static/image/public/images/flags/flag_91.d395508edb3c56c3e824ade084ae153f.svg","height":16,"width":24};